module.exports = __webpack_public_path__ + "static/img/fingerpost_buy_2.31d7deb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_buy_2.jpg
// module id = YAUI
// module chunks = 0